module.exports = __webpack_public_path__ + "img/form-x-2.ea687cb5.svg";